export default __webpack_public_path__ + "935c52f2faa6bc30d0985e9317db2210.svg";